<template lang="pug">
#modal-confirmar-inicio-analise-operacao
    el-dialog(
        :title="$t('mensagens.operacao.confirmarInicioAnalise')",
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 {{ $t('mensagens.operacao.aposAnaliseProibidoEdicoes') }}
        p
            b {{ $t('mensagens.operacao.formularioGleba.identificadorOperacao') }}:
            |
            | {{ operacao.identificador }}

        .buttons.d-flex.justify-content-between
            BaseButton(size='mini', @click='closeDialog()')
                | {{ $t('mensagens.comuns.fechar') }}
            BaseButton(
                type='primary',
                size='mini',
                @click='alterarStatusParaEmAnalise'
            )
                | {{ $t('mensagens.operacao.iniciarAnalise') }}
</template>

<script>
import StatusOperacao from '@/constants/StatusOperacao.js';
import OperacaoService from '@/services/OperacaoService.js';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalConfirmarInicioAnaliseOperacao',

    components: {
        BaseButton
    },

    emits: ['iniciarAnalise'],

    props: {
        operacao: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        closeDialog() {
            this.$emit('update:show', false);
        },

        async alterarStatusParaEmAnalise() {
            const analiseOperacao = {
                idOperacao: this.operacao.id,
                idStatusOperacao: StatusOperacao.EM_ANALISE,
                parecer: null
            };

            await OperacaoService.atualizarStatus(analiseOperacao)
                .then(() => {
                    this.$emit('iniciarAnalise');
                })
                .catch(erro => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.impossivelIniciarAnaliseOperacao')
                    });
                })
                .finally(() => {
                    this.closeDialog();
                });
        }
    }
};
</script>

<style lang="scss">
#modal-confirmar-inicio-analise-operacao {
    .center-align {
        text-align: center;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
